import {
  INIT,
} from '../constants';

export default function siteContextReducer(state = {}, action) {
  switch (action.type) {
    case INIT:
      return action.payload.siteContext;
    default:
      return state;
  }
}
